import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@codex/icons';

import { FilterLP, FilterHeader, FilterHeaderClosed } from '../styled';

export default class DesktopFilterItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      opened: props.openByDefault
    };
  }

  openOrCloseFilter() {
    this.setState((prevState) => ({
      opened: !prevState.opened
    }));
  }

  render() {
    return (
      <FilterLP
        className={`dc-filter-lp ${
          this.state.opened ? 'dc-filter--selected' : 'dc-filter--closed'
        }`}
        selected={this.state.opened}
        closed={!this.state.opened}
      >
        <FilterHeader // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
          className={'dc-filter__header'}
          onClick={() => {
            this.openOrCloseFilter();
          }}
          onKeyPress={() => {
            this.openOrCloseFilter();
          }}
        >
          <FilterHeaderClosed className={'dc-filter__header--closed'}>
            {this.props.label}
          </FilterHeaderClosed>
          <Icon icon={'ChevronRight'} size={'large'} rotate={this.state.opened ? 270 : 90} />
        </FilterHeader>
        {this.state.opened ? this.props.children : null}
      </FilterLP>
    );
  }
}

DesktopFilterItem.propTypes = {
  children: PropTypes.element,
  label: PropTypes.string.isRequired,
  openByDefault: PropTypes.bool
};

DesktopFilterItem.defaultProps = {
  children: null,
  openByDefault: PropTypes.bool
};
